import BaseClass from "../../libs/base/BaseClass";
import PassengerCountClass from "./PassengerCountClass";

/**
 * 検索枠での人数管理の基礎クラス
 */
export default class PassengerBaseClass extends BaseClass{
    constructor(_target){
        super();
        this.name = "PassengersClass";

        this.EVENT_CHANGE = "eventChange";
        this.EVENT_ERROR = "eventError";

        this.target = _target;

        this.onChangeChildListerner = this.onChangeChild.bind(this);

        this.childSelectItems = [];

        this.nowData = {
            adult:{
                count:1
            },
            child:{
                count:0,
                list:[]
            }
        };

        this.maxNum = 6;
        this.isOver = false;
    }

    onCreate() {
        super.onCreate();

        this.HTML_TEMPLATE_YERS_OLD = $(".years_old_template",this.target).html();
        this.HTML_TEMPLATE_YERS_OLD_SELECT = $(".years_old_select_template",this.target).html();

        this.adult = new PassengerCountClass($(".count.adult",this.target));
        this.child = new PassengerCountClass($(".count.child",this.target));
        this.child.isAdult = false;
        //console.log(this.name,"-----",this.target,this.adult);

        this.adult.onCreate();
        this.child.onCreate();

        this.prevChildN = this.child.n;

        this.adult.on(this.adult.EVENT_CLICK_MINUS,this.onClick_adultMinus.bind(this));
        this.adult.on(this.adult.EVENT_CLICK_PLUS,this.onClick_adultPlus.bind(this));
        this.child.on(this.child.EVENT_CLICK_MINUS,this.onClick_childMinus.bind(this));
        this.child.on(this.child.EVENT_CLICK_PLUS,this.onClick_childPlus.bind(this));

        this.child.on(this.child.EVENT_CHANGE,this.onChangeChildListerner);
    }

    onClick_adultMinus(){
        if(this.onChangeCount({adult:-1})){
            this.onError();
        } else {
            this.adult.onAdd(-1);
        }
    }

    onClick_adultPlus(){
        if(this.onChangeCount({adult:1})){
            this.onError();
        } else {
            this.adult.onAdd();
        }
    }

    onClick_childMinus(){
        if(this.onChangeCount({child:-1})){
            this.onError();
        } else {
            this.child.onAdd(-1);
        }
    }

    onClick_childPlus(){
        if(this.onChangeCount({child:1})){
            this.onError();
        } else {
            this.child.onAdd();
        }
    }

    onPositive(){
        this.nowData.adult.count = this.adult.n;
        this.nowData.child.count = this.child.n;
        const childList = [];
        $("select",this.childYearsoldArea).each(function(){
            childList.push($(this).val());
        });
        this.nowData.child.list = childList;
        //console.log(this.name,"onPositive",this.nowData);
    }

    onNegative(){
        //console.log(this.name,"onNegative");

        this.adult.onCountChange(this.nowData.adult.count,true);
        this.child.onCountChange(this.nowData.child.count,true);

        this.prevChildN = this.nowData.child.count;

        this.removeChildSelectArea();
        if(this.prevChildN === 0){
            //this.removeChildSelectArea();
        } else {
            this.childSelectItems = [];
            this.addChildSelectArea();
            for(let i=0;i<this.nowData.child.list.length;i++){
                const val = this.nowData.child.list[i];
                this.addChildSelect(val);
            }
        }
    }

    onChangeChild(){
        if(this.prevChildN === 0 && this.child.n > 0){
            this.addChildSelectArea();
        }
        if(this.prevChildN > 0 && this.child.n === 0){
            this.removeChildSelectArea();
        }
        if(this.child.n > this.prevChildN){
            this.addChildSelect(null);
        } else {
            this.removeChildSelect();
        }

        this.prevChildN = this.child.n;
    }

    onChangeCount(_params){
        const adult = (_params.adult)? this.adult.n + _params.adult : this.adult.n ;
        const child = (_params.child)? this.child.n + _params.child : this.child.n ;
        const total = adult + child;
        //console.log(this.name,"onChangeCount",total);
        return (total > this.maxNum);
    }

    onError(){}

    onCheckSubmitError(){
        let isError = false;
        let msg = "";
        let data = null;
        if(this.childYearsoldArea){
            const self = this;
            $("select",this.childYearsoldArea).each(function(){
                const yo = parseInt($(this).val());
                if(Number.isNaN(yo)) {
                    isError = true;
                    msg = LtikeCommon.TEXT.ERROR_PASSENGER_YEARS_OLD_UNKNOWN;
                    return false;
                }
            });
        }
        return {isError:isError,msg:msg,data:data};
    }

    onSetData(_data){
        const adult = _data.adult;
        const ageList = _data.ageList;
        //console.log(this.name,_data,ageList);

        this.adult.onCountChange(adult,true);
        //this.child.onCountChange(childTotal,true);
        //console.log(this.name,"onSetData",_data,childTotal);

        if(ageList.length !== 0 && this.childYearsoldArea !== null){
            this.addChildSelectArea();
        }

        for(let i=0;i<ageList.length;i++){
            //console.log(i,ageList[i]);
            //this.addChildSelect(null);
            this.child.onCountChange(i+1,true);
            this.addChildSelect(ageList[i]);
        }

        this.onPositive();

        this.prevChildN = this.child.n;
    }

    addCount(_params){
        if(_params.adult) this.adult.onAdd(_params.adult);
        if(_params.child) this.child.onAdd(_params.child);
    }

    getPassengers(){
        let child = 0;
        let ageList = [];
        if(this.childYearsoldArea){
            $("select",this.childYearsoldArea).each(function(){
                const yo = parseInt($(this).val());
                child++;
                ageList.push(yo);
                //console.log(yo);
            });
        }
        //console.log("------",ageList);
        return {adult:this.adult.n,child:child,ageList:ageList};
    }

    addChildSelectArea(){
        this.childYearsoldArea = $(this.HTML_TEMPLATE_YERS_OLD).appendTo($(".child_years_old_insert_target",this.target));
        //console.log(this.name,"addChildSelectArea",this.childYearsoldArea);
    }

    removeChildSelectArea(){
        if(!this.childYearsoldArea) return;
        this.childYearsoldArea.remove();
        this.childYearsoldArea = null;
        this.childSelectItems = [];
    }

    addChildSelect(_defaultVal){
        const item = $(this.HTML_TEMPLATE_YERS_OLD_SELECT).appendTo($("dd",this.childYearsoldArea));
        if(_defaultVal !== null) $("select",item).val(_defaultVal);
        this.childSelectItems.push(item);
        //console.log(this.name,"addChildSelect",item,_defaultVal,this.childSelectItems,this.childYearsoldArea);
    }

    removeChildSelect(){
        if(this.childSelectItems.length <= 0) return;
        this.childSelectItems[this.childSelectItems.length-1].remove();
        this.childSelectItems.pop();
        //console.log(this.name,"removeChildSelect",this.childSelectItems,this.childYearsoldArea);
    }
}